import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div className={`relative ${sizeClasses[size]}`}>
        <span className="absolute inset-0 rounded-full border border-slate-200" />
        <span className="absolute inset-0 animate-spin rounded-full border-2 border-transparent border-r-sky-500 border-t-sky-600" />
      </div>
    </div>
  );
};

export default LoadingSpinner;
